// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__P6kIQ","contentContainer":"styles_contentContainer__WmbOi","calorie":"styles_calorie__yDTbv"};